import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import {
  Button,
  Col,
  Form,
  Icon,
  Input,
  Modal,
  Row,
  Upload,
  message
} from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { getBase64 } from '../../../../utils/services'


const RESERVED_NAMES = ['BKKWastePay', 'WakeUpWaste']
const MAX_LOGO_MB = 2

const ApiPartnerForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields } = form
  const isEdit = !_.isEmpty(formData)
  const [logo, setLogo] = useState(null)
  const [logoPreview, setLogoPreview] = useState('')

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      form.setFieldsValue({
        name: formData.name,
        baseUrl: formData.baseUrl,
        partnerTokenEndpoint: formData.partnerTokenEndpoint
      })
    }
    return () => {
      form.resetFields()
      setLogo(null)
      setLogoPreview('')
    }
  }, [formData])

  function beforeUpload(file) {
    if (!file.type.startsWith('image/')) {
      message.error('รองรับเฉพาะไฟล์รูปภาพ')
      return false
    }
    if (file.size / 1024 / 1024 > MAX_LOGO_MB) {
      message.error(`ไฟล์ต้องไม่เกิน ${MAX_LOGO_MB}MB`)
      return false
    }
    setLogo(file)
    getBase64(file, setLogoPreview)
    return false
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields((err, values) => {
      if (err) return
      const data = new FormData()
      data.append('name', values.name.trim())
      data.append('baseUrl', values.baseUrl.trim())
      data.append('partnerTokenEndpoint', (values.partnerTokenEndpoint || '').trim())
      if (!isEdit) {
        data.append('username', values.username.trim())
        data.append('password', values.password)
      }
      if (logo) data.append('logo', logo)
      onOk(data)
    })
  }

  return (
    <Modal
      title={`${isEdit ? 'แก้ไข' : 'สร้าง'} API Partner`}
      visible={visible}
      footer={null}
      onCancel={onCancel}
      width={560}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item style={{ display: 'flex', justifyContent: 'center' }}>
          <Upload
            accept="image/*"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={beforeUpload}>
            {logoPreview || formData.logoUrl ? (
              <img
                src={logoPreview || formData.logoUrl}
                alt="logo"
                style={{ width: '100%' }}
              />
            ) : (
              <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
              </div>
            )}
          </Upload>
        </Form.Item>

        <Form.Item label="ชื่อ Partner">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'กรุณากรอกชื่อ' }]
          })(
            <Input
              disabled={isEdit && RESERVED_NAMES.includes(formData.name)}
              placeholder="เช่น BKKWastePay"
            />
          )}
        </Form.Item>

        <Form.Item label="Base URL">
          {getFieldDecorator('baseUrl', {
            rules: [{ required: true, message: 'กรุณากรอก Base URL' }]
          })(<Input placeholder="https://api.partner.com" />)}
        </Form.Item>

        <Form.Item label="Token Endpoint">
          {getFieldDecorator('partnerTokenEndpoint', {
            rules: [{ required: !isEdit, message: 'กรุณากรอก Token Endpoint' }]
          })(<Input placeholder="auth/login" />)}
        </Form.Item>

        {!isEdit && (
          <Row gutter={8}>
            <Col span={12}>
              <Form.Item label="Username">
                {getFieldDecorator('username', {
                  rules: [{ required: true, message: 'กรุณากรอก Username' }]
                })(<Input autoComplete="off" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Password">
                {getFieldDecorator('password', {
                  rules: [{ required: true, message: 'กรุณากรอก Password' }]
                })(<Input.Password autoComplete="new-password" />)}
              </Form.Item>
            </Col>
          </Row>
        )}
        {isEdit && (
          <div style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>
            ไม่สามารถแก้ไข Username / Password
            เนื่องจากขึ้นอยู่กับ Partner ผู้ให้บริการ
          </div>
        )}

        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default Form.create({ name: 'ApiPartnerForm' })(ApiPartnerForm)
